module.exports = __webpack_public_path__ + "img/Uni-of-Oklahoma-logo.a5b54fa5.png";